import { render, staticRenderFns } from "./link-viewer.vue?vue&type=template&id=4fbfbd52"
import script from "./link-viewer.vue?vue&type=script&lang=js"
export * from "./link-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports